<div
  class="information-headline"
  [ngClass]="{'smallScreen': smallScreen}"
>
  <div class="information-headline__title">
    @if (smallScreen && !isEditing) {
      <a
        (click)="onToggleMenu()"
        class="information-headline__toggle-button"
      >
        <mat-icon>
          {{openMenu ? 'menu_open' : 'menu'}}
        </mat-icon>
      </a>
    }

    <div class="information-headline__headline-container">
      @if (operationContainer?.contentInfo.curListName === 'overview') {
        <h3>
          @if (operationContainer.rootSectionsContainer) {
            <span [innerHTML]="operationContainer.rootSectionsContainer.objectView.artifact_name"></span>
          }
        </h3>
      }
      @else {
        <h3>
          <span>
            {{contentListHeadline}}&nbsp;
          </span>

          @if (!operationContainer.contentInfo.curContentListSource) {
            <span>
              ({{operationContainer.contentInfo.selectedMainMenu.count}})
            </span>
          }
          @else {
            <span>
              ({{operationContainer.contentInfo.curContentListSource?.array.length}})
            </span>
          }
        </h3>
      }
    </div>
  </div>

  @if (operationContainer?.currentOperation?.operation_type === 'operation') {
    <ng-container>
      @for (operation of operationContainer.currentOperation.operation_steps; track $index) {
        <ng-container>
          @if (operation.operation_step_type === 'edit_object' && !isEditing) {
            <button
              class="information-headline__button"
              mat-stroked-button
              color="primary"
              type="button"
              (click)="setEdit()"
              [disabled]="isEditing"
            >
              <mat-icon>
                edit
              </mat-icon>

              <span class="bold uppercase">
                {{ 'TRANS__HEADER__EDIT' | translate }}
              </span>
            </button>
          }
        </ng-container>
      }
    </ng-container>
  }

  @if (operationContainer?.contentInfo.curListName !== 'overview' && currentGroupOperation.operation_type === 'group') {
    <ng-container>
      <app-operation-menus-two-levels
        class="information-headline__button-container"
        [operationContainer]="operationContainer"
        [parentOperation]="currentGroupOperation"
      ></app-operation-menus-two-levels>
    </ng-container>
  }
</div>
